import { useChatWithAuthHeaders } from '@/api/ai';
import { useMessages } from '@/api/chat';
import { HandleSubmitMessageType } from '@/utils/aiUtils';
import { type ChatContext } from '@ditto/shared';
import { useEffect } from 'react';

export const useChat = (
  getChatContext: () => ChatContext,
  firstUserMessage?: HandleSubmitMessageType
) => {
  const { messages, setMessages, regenerate, ...rest } =
    useChatWithAuthHeaders(getChatContext);

  const chatContext = getChatContext();

  const { data: initialMessages, isPending } = useMessages(chatContext.id);

  useEffect(() => {
    if (
      !!initialMessages?.data?.length &&
      initialMessages.data.length > messages.length &&
      !isPending
    ) {
      setMessages(initialMessages.data);
    }
    if (
      !!firstUserMessage &&
      messages.length === 0 &&
      !isPending &&
      !initialMessages?.data?.length
    ) {
      const messageId = crypto.randomUUID();
      const messageText =
        'text' in firstUserMessage ? firstUserMessage.text || '' : '';
      setMessages([
        {
          id: messageId,
          role: 'user',
          parts: [{ type: 'text', text: messageText }],
          metadata: firstUserMessage?.metadata,
        },
      ]);
      regenerate({ messageId });
    }
  }, [initialMessages, isPending, firstUserMessage]);

  return {
    messages,
    isPending,
    setMessages,
    regenerate,
    ...rest,
  };
};
